import { C } from "../../lib/constants";
import { Btn } from "./Btn";
import { TopNav } from "./TopNav";

export const LoginRequiredBox = ({setScreen, title="Inicia sesión", desc="Para usar esta función necesitas entrar con tu cuenta de cliente."}) => (
  <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
    <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Acceso requerido"/>
    <div style={{maxWidth:560,margin:"0 auto",padding:"28px 20px"}}>
      <div style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:24,padding:28,textAlign:"center",boxShadow:"0 8px 28px rgba(0,0,0,.08)"}}>
        <div style={{fontSize:54,marginBottom:12}}>🔐</div>
        <div style={{fontFamily:"Georgia, serif",fontSize:25,fontWeight:900,color:C.text,marginBottom:8}}>{title}</div>
        <div style={{color:C.sub,fontSize:14,lineHeight:1.6,marginBottom:18}}>{desc}</div>
        <Btn full color={C.accent} onClick={()=>setScreen("cliente-login")}>Iniciar sesión</Btn>
        <div style={{height:10}}/>
        <Btn full outline color={C.accent} onClick={()=>setScreen("reg-client")}>Crear cuenta</Btn>
      </div>
    </div>
  </div>
);
